import React from 'react'
import { FormattedMessage } from 'react-intl'
// @ts-expect-error — importing js
import moment from 'moment/min/moment-with-locales'
import { isUndefined } from 'lodash-es'

import { CountdownComponent } from '../WebinarCountdown/WebinarCountdown'

import './ScheduleTimerComponent.scss'

interface ScheduleTimerComponentProps {
  startTimeEpoch?: number | string
  renderOnlyTimer?: boolean
  onLiveCountdownZero?: () => void
}

const ScheduleTimerComponent = ({
  startTimeEpoch,
  renderOnlyTimer,
  onLiveCountdownZero,
}: ScheduleTimerComponentProps) => {
  if (isUndefined(startTimeEpoch)) {
    return null
  }

  const startTime = moment.unix(startTimeEpoch)

  const countdown = (
    <CountdownComponent
      timestamp={startTimeEpoch}
      onCountdownZero={onLiveCountdownZero}
    />
  )

  const isPast = startTime.isBefore(new Date())

  return (
    <span className="schedule-timer-component">
      {renderOnlyTimer ? (
        <div className="icon-and-timer">{countdown}</div>
      ) : (
        <>
          {isPast ? (
            <FormattedMessage
              defaultMessage="Event was scheduled to be live {countdown}"
              values={{ countdown }}
            />
          ) : (
            <FormattedMessage
              defaultMessage="Event is scheduled to be live {countdown}"
              values={{ countdown }}
            />
          )}
        </>
      )}
    </span>
  )
}

export default ScheduleTimerComponent
